import CTAButton from "../../atoms/CTAButton/CTAButton";
import { CustomContainer, Router } from "../../atoms/DependencyHelper";
import styles from "./MoreUpgradeDeals.module.scss";
import * as Analytics from "../../../services/analyticsUtag";
const MoreUpgradeDeals = () => {
    const handleQualifyDeals = () => {
        Router.push(`/shopping/deals`);
        Analytics.link({
            link_type: "o",
            link_name: "shopping: upgrade: recommended deals: more:browse all deals"
        });
    }
    const handleProducts = () => {
        Router.push('/shopping/products');
        Analytics.link({
            link_type: "o",
            link_name: "shopping: upgrade: recommended deals:  more:browse all products"
        });
    }
    return (
        <CustomContainer className={styles["more-upgrade"]}>
            <CustomContainer className={styles["more-upgrade__heading"]}>{"Can’t find a recommended deal you like?"}</CustomContainer>
            <CustomContainer className={styles["more-upgrade__description"]}>{"No problem! You can still find an upgrade deal by browsing the rest of our website."}</CustomContainer>
            <span className={styles["more-upgrade__browse-btn"]}><CTAButton handleClick={handleQualifyDeals} variant="primary">{"Browse all deals i qualify for "} </CTAButton></span>

            <CTAButton handleClick={handleProducts} variant={"outline black"}>{"Browse all products"}</CTAButton>
        </CustomContainer>
    );
}

export default MoreUpgradeDeals;